var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cartItemRemove"},[_c('q-btn',{staticClass:"no-hover",attrs:{"no-caps":"","unelevated":"","loading":_vm.deleting,"padding":!_vm.isText ? '' : '0'},on:{"click":function($event){return _vm.deleteCartItem()}}},[(!_vm.isText)?_c('SvgIcon',{attrs:{"icon":"trash","size":"1rem"}}):[_vm._v("Delete")]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }